
<div #mytemplate [ngClass]="{'desktop-detail-booking' : isDesktopMode()}" >
  <app-desktop-guest-booking-details *ngIf="isDesktopMode()" [booking]="booking" [property]="property" [corporate]="corporate"></app-desktop-guest-booking-details>
</div>
